// eslint-disable-next-line import/prefer-default-export
export const TABLE_VIEW_SHARED_TYPES = {
  PRIVATE: 'private',
  GLOBAL: 'global',
  ROLE_SPECIFIC: 'role_specific',
};
